import { TextField, Typography } from '@scale/scaleui';
import { useState, useCallback } from 'react';
import { copyToClipboard } from 'react-scale/lib/clipboard';
import { getShareUrl } from './utils';

export function ChatShareBox({
  slug,
}: {
  slug: string;
  defaultTitle?: string;
  editable?: boolean;
}) {
  const shareUrl = getShareUrl(slug);
  const [copiedSuccess, setCopiedSuccess] = useState<boolean>(false);

  const handleCopyToClipboard = useCallback(() => {
    copyToClipboard(shareUrl, { copyRaw: true });
    setCopiedSuccess(true);
    setTimeout(() => {
      setCopiedSuccess(false);
    }, 2000);
  }, [shareUrl]);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col gap-1 w-96">
        <div className="ml-0">
          <Typography.Caption>
            {copiedSuccess ? 'URL copied to clipboard!' : 'Copy this link to share this dialogue.'}
          </Typography.Caption>
        </div>
        <TextField
          id="url"
          value={shareUrl}
          trailingIcon={copiedSuccess ? ['far', 'check-circle'] : ['far', 'link']}
          onTrailingIconClick={handleCopyToClipboard}
        />
      </div>
    </div>
  );
}
